import { Alert } from "@chakra-ui/react";
import type { ReactElement } from "react";

export default function ErrorBoundaryFallback(): ReactElement {
    return (
        <Alert.Root status="error">
            <Alert.Indicator />
            <Alert.Title>Something went wrong</Alert.Title>
        </Alert.Root>
    );
}
